import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Radar } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@breakoutradar.io");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid-lines flex items-center justify-center bg-[#09090B] p-6">
      <div className="w-full max-w-sm border border-[#27272A] bg-[#18181B] fadein">
        <div className="px-6 py-5 border-b border-[#27272A] flex items-center gap-2">
          <Radar className="text-emerald-400" size={22} />
          <div>
            <div className="font-head font-bold tracking-tight">Breakout Radar</div>
            <div className="text-[10px] text-[#71717A] font-mono tracking-widest">INTERNAL ANALYST ACCESS</div>
          </div>
        </div>
        <form onSubmit={submit} className="p-6 space-y-4">
          <div>
            <label className="text-[11px] uppercase tracking-widest text-[#A1A1AA] font-mono">Email</label>
            <input
              data-testid="login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full bg-[#09090B] border border-[#27272A] focus:border-[#71717A] outline-none px-3 py-2 text-sm font-mono"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-widest text-[#A1A1AA] font-mono">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full bg-[#09090B] border border-[#27272A] focus:border-[#71717A] outline-none px-3 py-2 text-sm font-mono"
              autoComplete="current-password"
            />
          </div>
          {error && (
            <div data-testid="login-error" className="text-xs text-rose-400 border border-rose-900/60 bg-rose-950/20 px-3 py-2">
              {error}
            </div>
          )}
          <button
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-emerald-500 hover:bg-emerald-400 text-[#09090B] font-semibold text-sm py-2.5 transition-colors disabled:opacity-50"
          >
            {loading ? "Authenticating…" : "Access Terminal"}
          </button>
        </form>
      </div>
    </div>
  );
}
